"use client";

import { c as _c } from "react/compiler-runtime";
import dayjs from 'dayjs';
import { FiCheck, FiCalendar, FiTarget } from "react-icons/fi";
import RatingStar from "@/Components/Common/Icons/RatingStar";
import { formatSpecialty } from './utils';
import { getConfidenceLevel } from '../reviewListingComponents/ConfidenceComponents';
import { getAccessibilityLevel } from '../reviewListingComponents/AccessibilityComponents';
const ReviewHeader = t0 => {
  const $ = _c(57);
  const {
    review,
    isInModal: t1,
    actions: t2
  } = t0;
  const isInModal = t1 === undefined ? false : t1;
  const actions = t2 === undefined ? null : t2;
  let t3;
  if ($[0] !== review.confidenceScore) {
    t3 = getConfidenceLevel(review.confidenceScore);
    $[0] = review.confidenceScore;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const confidenceLevel = t3;
  let t4;
  if ($[2] !== review.accessibility) {
    t4 = getAccessibilityLevel(review.accessibility);
    $[2] = review.accessibility;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const accessibilityLevel = t4;
  const t5 = `bg-white rounded-xl sm:rounded-2xl border border-gray-200 p-3 sm:p-6 ${isInModal ? "" : "mb-3 sm:mb-4"} hover:shadow-sm transition-shadow`;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      backgroundColor: "#1E5EFF"
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== review.physicianDetails?.speciality) {
    t7 = formatSpecialty(review.physicianDetails?.speciality)?.charAt(0).toUpperCase() || "H";
    $[5] = review.physicianDetails?.speciality;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t7) {
    t8 = <div className="w-7 sm:w-14 h-7 sm:h-14 rounded-full flex items-center justify-center flex-shrink-0" style={t6}><span className="text-white text-[10px] sm:text-xl font-bold font-poppins">{t7}</span></div>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = review.physicianDetails?.speciality;
  let t10;
  if ($[9] !== t9) {
    t10 = formatSpecialty(t9);
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10) {
    t11 = <span className="text-[11px] sm:text-base font-semibold text-gray-900 font-poppins leading-tight">{t10}</span>;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="text-green-500"><FiCheck className="w-2.5 sm:w-4 h-2.5 sm:h-4" strokeWidth={3} /></span>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t11) {
    t13 = <div className="flex items-center gap-1 sm:gap-2">{t11}{t12}</div>;
    $[14] = t11;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const t14 = review.physicianDetails?.region || "Northeast US";
  let t15;
  if ($[16] !== review.createdAt) {
    t15 = dayjs(review.createdAt).format("MMM DD, YYYY");
    $[16] = review.createdAt;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t14 || $[19] !== t15) {
    t16 = <p className="text-[9px] sm:text-sm text-gray-500 font-poppins leading-tight mt-0.5">{t14} • {t15}</p>;
    $[18] = t14;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== review.indication) {
    t17 = review.indication && <p className="text-[9px] sm:text-sm text-gray-400 font-poppins leading-tight mt-0.5">For <span className="font-medium text-gray-700">{review.indication}</span></p>;
    $[21] = review.indication;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t13 || $[24] !== t16 || $[25] !== t17) {
    t18 = <div className="flex-1 min-w-0">{t13}{t16}{t17}</div>;
    $[23] = t13;
    $[24] = t16;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== review.individualAverage) {
    t19 = review.individualAverage?.toFixed(1) || "0.0";
    $[27] = review.individualAverage;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t19) {
    t20 = <span className="text-xs sm:text-2xl font-bold text-gray-900 font-poppins">{t19}</span>;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  const t21 = `review_card_star_${review._id || "default"}`;
  let t22;
  if ($[31] !== t21) {
    t22 = <RatingStar className="w-3 sm:w-5 h-3 sm:h-5" fill="#1E5EFF" clipId={t21} />;
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== t20 || $[34] !== t22) {
    t23 = <div className="flex items-center gap-0.5 sm:gap-2 sm:bg-gray-50 sm:rounded-xl sm:px-4 sm:py-2">{t20}{t22}</div>;
    $[33] = t20;
    $[34] = t22;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== actions || $[37] !== t23) {
    t24 = <div className="flex items-start gap-1 sm:gap-2 flex-shrink-0">{t23}{actions}</div>;
    $[36] = actions;
    $[37] = t23;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t18 || $[40] !== t24) {
    t25 = <div className="flex-1 min-w-0"><div className="flex items-start justify-between gap-2">{t18}{t24}</div></div>;
    $[39] = t18;
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t25 || $[43] !== t8) {
    t26 = <div className="flex items-start gap-2 sm:gap-4">{t8}{t25}</div>;
    $[42] = t25;
    $[43] = t8;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  const t27 = review.review || "[No additional comments provided]";
  let t28;
  if ($[45] !== t27) {
    t28 = <p className="text-[11px] sm:text-sm text-gray-700 font-poppins mt-2 sm:mt-4 leading-relaxed">"{t27}"</p>;
    $[45] = t27;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== accessibilityLevel || $[48] !== confidenceLevel || $[49] !== review.accessibility || $[50] !== review.confidenceScore) {
    t29 = (review.confidenceScore != null || review.accessibility != null) && <div className="mt-2 sm:mt-4 pt-2 sm:pt-4 border-t border-gray-100 flex items-center gap-3 sm:gap-8">{review.confidenceScore != null && <div className="flex sm:flex-col items-center sm:items-start gap-1 sm:gap-0"><span className="text-[9px] sm:text-[11px] text-gray-400 font-poppins uppercase tracking-wider">Confidence:</span><span className="text-[11px] sm:text-base font-semibold text-gray-900 font-poppins">{confidenceLevel.score}%</span></div>}{review.accessibility != null && <div className="flex sm:flex-col items-center sm:items-start gap-1 sm:gap-0"><span className="text-[9px] sm:text-[11px] text-gray-400 font-poppins uppercase tracking-wider">Accessibility:</span><span className="text-[11px] sm:text-base font-semibold text-gray-900 font-poppins">{accessibilityLevel.score}%</span></div>}</div>;
    $[47] = accessibilityLevel;
    $[48] = confidenceLevel;
    $[49] = review.accessibility;
    $[50] = review.confidenceScore;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== t26 || $[53] !== t28 || $[54] !== t29 || $[55] !== t5) {
    t30 = <div className={t5}>{t26}{t28}{t29}</div>;
    $[52] = t26;
    $[53] = t28;
    $[54] = t29;
    $[55] = t5;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  return t30;
};
export default ReviewHeader;